module.exports = __webpack_public_path__ + "static/media/identification.920bf7b7.svg";